import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import Config from "../../Config";
import {
  SubmitBtn,
  PreviewBtn,
  OtherBtn,
  InputGroup,
  FieldWrapper,
  Label,
  FormContainer,
  CombineInputGroup,
} from "../../Components/Styles/InputStyles";


const ViewModel = ({ setPreviewOpenModel, selectedItem }) => {
  const parseTypeofGames = (values) => {
    if (values == null)
      return 'NA';
    var typeOfGames = '';
    selectedItem?.games.map((ln, i) => {
      if (typeOfGames == '')
        typeOfGames = ln.label;
      else
        typeOfGames = typeOfGames + "," + ln.label;
    })
    return typeOfGames;
  }
  return (
    <Model width={"w-11/12 max-w-2xl"} setOpenModel={setPreviewOpenModel}>
      <Wrapper>
        <Title>Preview Form</Title>
        <SingleItem name={"Assoc Name"} value={selectedItem?.assocName} />
        <SingleItem name={"Type Of Game"} value={parseTypeofGames(selectedItem?.games) || "NA"} />
        <SingleItem name={"Type Of Registration"} value={selectedItem?.typeOfRegLabel || "NA"} />
        <SingleItem name={"Type Of Assocation"} value={selectedItem?.typeOfAssocLabel || "NA"} />
        <SingleItem name={"Region"} value={selectedItem?.regionLabel || "NA"} />
        <SingleItem name={"District"} value={selectedItem?.districtLabel || "NA"} />
        <SingleItem name={"Council"} value={selectedItem?.councilLabel || "NA"} />
        <SingleItem name={"Office Address"} value={selectedItem?.officeAddr || "NA"} />
        <SingleItem name={"Postal Address"} value={selectedItem?.postalAddr || "NA"} />
        <SingleItem name={"Objective"} value={selectedItem?.objective || "NA"} />
        <SingleItem name={"Affi. to Other Org."} value={selectedItem?.affiliateInfo || "NA"} />
        <SingleItem name={"No Of Members"} value={selectedItem?.noOfMembers || "NA"} />
        {/* <SingleItem name={"Formation Date"} value={selectedItem?.formationDate || "NA"} /> */}
        <SingleItem name={"Class of Persons"} value={selectedItem?.restrictionInfo || "NA" } />

        <SingleItem name={"Land Details"} value={selectedItem?.landDetails || "NA"} />

        {/* <SingleItem name={"337 Registration Name"} value={selectedItem?.name337 || "NA"} />
        <SingleItem name={"337 Registration number"} value={selectedItem?.number337 || "NA"} /> */}


        <SingleItem name={"Office Bear Title"} value={selectedItem?.officeBearTitle || "NA"} />
        <SingleItem name={"Holder Names"} value={selectedItem?.holderNames || "NA"} />
        <SingleItem name={"Holding Terms"} value={selectedItem?.holdingTerms || "NA"} />
        <SingleItem name={"Chairman Name"} value={selectedItem?.chairmanName || "NA"} />
        <SingleItem name={"Secretary Name"} value={selectedItem?.secretaryName || "NA"} />
        
        {selectedItem.chairmanSignature && 
          <SingleItem name={"Chairman Signature"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.chairmanSignature )} target="_blank">Chairman Signature</a>
          </LinkValue>} />
        }
        {selectedItem.secretarySignature && 
          <SingleItem name={"Secretary Signature"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.secretarySignature )} target="_blank">Secretary Signature</a>
          </LinkValue>} />
        }
        {selectedItem.constitution && 
          <SingleItem name={"Constitution Doc"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.constitution )} target="_blank">Constitution Doc</a>
          </LinkValue>} />
        }
        {selectedItem.mom && 
          <SingleItem name={"Mintue Of Meetings"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.mom )} target="_blank">Mintue Of Meetings</a>
          </LinkValue>} />
        }
        {selectedItem.financials && 
          <SingleItem name={"Financial Doc"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.financials )} target="_blank">Financials</a>
          </LinkValue>} />
        }
        {selectedItem.principals && 
          <SingleItem name={"Principals Doc"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.principals )} target="_blank">Principals Doc</a>
          </LinkValue>} />
        }
        {selectedItem.members && 
          <SingleItem name={"Member's Info"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.members )} target="_blank">Member's Info</a>
          </LinkValue>} />
        }
        {selectedItem.certificateName && 
          <SingleItem name={"Certificate"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.certificateName )} target="_blank">Download Certificate</a>
          </LinkValue>} />
        }

        <SingleItem name={"Applicate Date"} value={moment(new Date()).format("YYYY-MM-DD")} />

                        {/* <br></br>
                        <SubmitBtn type="submit" >
                          
                          SUBMIT
                        </SubmitBtn> */}
      
      </Wrapper>
    </Model>
  );
};

const SingleItem = ({ name, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    <Name>{name}</Name> <p className="w-10">:</p>
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link && <Value>{value}</Value>}
  </div>
);

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl mb-6 text-gray-700 font-medium text-left`;
const Name = tw.p`text-sm text-gray-500  w-40`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;

export default ViewModel;
